export const padNumberWithZeros = (id) => {
  if (id !== null && id !== undefined) {
    const paddedNumber = String(id).padStart(4, '0');
    return paddedNumber;
  } else {
    return id;
  }
};
